import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import FolderOpen from '@material-ui/icons/FolderOpen';
import Main from 'components/templates/Main';
import Errors from 'components/shared/Errors';
import Success from 'components/shared/Success';
import EmptyState from 'components/shared/EmptyState';
import { isCommissionHost as isCommissionHostSelector } from 'selectors/user';
import useHostFiles from '../hooks/useHostFiles';
import HostFilesList from '../components/HostFilesList';

const HostFilesContainer = () => {
  const isCommissionHost = useSelector(isCommissionHostSelector);

  if (!isCommissionHost) {
    return (
      <Main title={<FormattedMessage id="main.myFiles" defaultMessage="My files" />}>
        <EmptyState
          icon={FolderOpen}
          title={<FormattedMessage id="hostFiles.notAvailable" defaultMessage="Not available" />}
          description={
            <FormattedMessage
              id="hostFiles.notAvailableDescription"
              defaultMessage="This feature is available for hosts with listings."
            />
          }
        />
      </Main>
    );
  }

  return <HostFilesContainerContent />;
};

const HostFilesContainerContent = () => {
  const hf = useHostFiles();

  return (
    <Main title={<FormattedMessage id="main.myFiles" defaultMessage="My files" />}>
      <HostFilesList
        config={hf.config}
        files={hf.files}
        counts={hf.counts}
        groupedFiles={hf.groupedFiles}
        cottages={hf.cottages}
        isLoading={hf.isLoading}
        isUploading={hf.isUploading}
        uploadProgress={hf.uploadProgress}
        uploadFileIndex={hf.uploadFileIndex}
        uploadFileCount={hf.uploadFileCount}
        isUpdating={hf.isUpdating}
        onUpload={hf.onUpload}
        onView={hf.onView}
        onDownload={hf.onDownload}
        onRename={hf.onRename}
        onReassign={hf.onReassign}
        onDelete={hf.onDelete}
      />
      <Success success={hf.success} onClose={hf.onClearStatus} autoHideDuration={5000} />
      <Errors errors={hf.error} onClose={hf.onClearStatus} autoHideMs={5000} />
    </Main>
  );
};

export default HostFilesContainer;
